import React from "react";
import CustomLink from "../../common/link";

const NavMenu = ({ menu }) => {
  return (
    <ul className="mb-0 pl-0">
      {menu?.map((menuItem, index) => (
        <li key={index} className="mega-menu">
          <CustomLink
            classNames="text-inherit no-underline font-medium"
            data={menuItem}
          />
        </li>
      ))}
    </ul>
  );
};

export default NavMenu;
